import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { realTimeService } from 'src/app/services/services/realtime.service';
import { Profile } from 'src/app/app-models/realTimeModels';
import { phoneNumberValidator } from 'src/app/shared/form-validators';

@Component({
    selector: 'app-set-logOn-dialog',
    templateUrl: './set-logOn-dialog.component.html',
    styleUrls: ['./set-logOn-dialog.component.scss'],
    standalone: false
})

export class SetLogOnDialogComponent implements OnInit {
    phoneNumber: string = '';
    selectedProfileId: number | null = null;
    profiles: Profile[] = [];
    userName: string = '';
    isLoading: boolean = false;
    errorMessage: string = '';
    phoneNumberValid: boolean = true;
    phoneValidator = phoneNumberValidator();

    constructor(
        public dialogRef: MatDialogRef<SetLogOnDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public dialogData: any,
        private realTimeService: realTimeService
    ) { }

    ngOnInit() {
        this.userName = this.dialogData?.userName || '';
        this.phoneNumber = this.dialogData?.phoneNumber || '';
        this.loadProfiles();
    }

    loadProfiles() {
        this.isLoading = true;

        this.realTimeService.GetProfileList(this.dialogData?.userId).subscribe((profiles) => {
            this.profiles = profiles;
            this.selectedProfileId = profiles[0]?.id || null;
            this.isLoading = false;
        });
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    closeDialogWithResult(): void {
        if (this.validateForm()) {
            const result = {
                phoneNumber: this.phoneNumber,
                profileId: this.selectedProfileId,
                profileNumber: this.profiles.find(p => p.id === this.selectedProfileId)?.number || null
            };
            this.dialogRef.close(result);
        }
    }

    validateForm(): boolean {
        this.errorMessage = '';

        if (!this.phoneNumber.trim()) {
            this.errorMessage = 'Phone number is required';
            return false;
        }

        // Validate phone number format
        const phoneValidation = this.phoneValidator({ value: this.phoneNumber } as any);
        if (phoneValidation) {
            this.errorMessage = phoneValidation.phoneNumber.message;
            this.phoneNumberValid = false;
            return false;
        }

        if (!this.selectedProfileId) {
            this.errorMessage = 'Profile is required';
            return false;
        }

        this.phoneNumberValid = true;
        return true;
    }

    onPhoneNumberChange(): void {
        // Reset validation state when user starts typing
        this.phoneNumberValid = true;
        this.errorMessage = '';
    }
}
